/**
 * Created by Administrator on 2018/4/13.
 */
function toNum(a) {
  var a = a.toString();
  //也可以这样写 var c=a.split(/\./);
  var c = a.split('.');
  var r=["0000","000",'00',"0",""];
  for (var i = 0; i < c.length; i++) {
    var len = c[i].length;
    c[i] = r[len] + (c[i]+'');
  }
  var res = c.join('');
  return res;
}
/**
 * 比较版本号cpr_version("2.2.3","2.1.15");
 * @param a
 * @param b
 * @returns {*}
 */
export function cpr_version(a, b) {
  var _a = toNum(a), _b = toNum(b);
  if (_a == _b) return 0;
  if (_a > _b) return 1;
  if (_a < _b) return -1;
}
export function goBack() {
  window.history.length > 1
    ? this.$router.go(-1)
    : this.$router.push('/')
}
//判断是否是数字
export function isRealNum(val){
  // isNaN()函数 把空串 空格 以及NUll 按照0来处理 所以先去除
  if(val === "" || val ==null){
    return false;
  }
  if(!isNaN(val)){
    return true;
  }else{
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/util/tools.js